export default __webpack_public_path__ + "e845f26112e3866c8ba0819ebec3f893.svg";